module.exports = __webpack_public_path__ + "img/img34.2b8de21e.svg";